var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-slider slide"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],style:(_vm.style),attrs:{"type":"range","tabindex":"-1","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":(_vm.value)},on:{"change":_vm.valueUpdate,"__r":function($event){_vm.value=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e310cd2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/inputs/FormSlider.vue
// module id = fh2j
// module chunks = 1